import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ILocalization } from '../../form-fields/models/form.model';

@Pipe({
  name: 'translateObject',
  pure: false,
  standalone: true
})
export class TranslateObjectPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(
    translationsObject: ILocalization,
    nullPlaceholder?: string
  ): string {
    const currentLanguage =
      this.translateService.currentLang || this.translateService.defaultLang;

    return currentLanguage === 'en'
      ? translationsObject &&
        translationsObject.en &&
        translationsObject.en !== ''
        ? translationsObject.en
        : (nullPlaceholder ?? '')
      : translationsObject &&
          translationsObject.ar &&
          translationsObject.ar !== ''
        ? translationsObject.ar
        : (nullPlaceholder ?? '');
  }
}
